var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{on:{"showShortCut":_vm.handleShortCut}}),_c('short-cut',{attrs:{"keyBoardVisible":_vm.keyBoardVisible},on:{"update:keyBoardVisible":function($event){_vm.keyBoardVisible = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }